export default [
  {label: 'Segunda-feira', value: 'Monday'},
  {label: 'Terça-feira', value: 'Tuesday'},
  {label: 'Quarta-feira', value: 'Wednesday'},
  {label: 'Quinta-feira', value: 'Thursday'},
  {label: 'Sexta-feira', value: 'Friday'},
  {label: 'Sábado', value: 'Saturday'},
  {label: 'Domingo', value: 'Sunday'},
];
